export const pagesProductPlanningCoreEn = {
  productScopeReconciliation: {
    anchorDate: {
      missingTarget: 'No target product selected',
      missingTargetDescription: 'Go back and select a target product.',
      pageTitle: 'Set the Reference Date',
      start: 'Start',
      startFailed: 'Failed to start product scope stocktaking',
      startSuccess: 'Product scope stocktaking started'
    },
    instance: {
      adjustInDataTab: 'Review in the Data tab',
      adjustInDataTabDescription: 'Review the product scope tree and complete this task in the Data tab.',
      approveAll: 'Approve all',
      approveAllSuccess: 'Approved all successfully',
      assignee: 'Assignee',
      backToCore: 'Product Planning Core',
      cannotApproveAll: 'Cannot approve all because there are no waiting approval tasks',
      data: {
        aiRecommended: 'AI Recommended',
        complete: 'Complete Scope Adjustment',
        completeSuccess: 'Scope adjustment completed',
        description: 'Review the current product scope tree. AI recommended scope will be highlighted when available.',
        diff: {
          addedBadge: 'Proposed Addition',
          changedBadge: 'Proposed Change',
          field: {
            name: 'Name',
            objective: 'Objective'
          },
          removedBadge: 'Proposed Removal',
          summaryAdded: 'Added: {{count}}',
          summaryChanged: 'Changed: {{count}}',
          summaryRemoved: 'Removed: {{count}}',
          summaryTitle: 'AI Proposed Changes'
        },
        missingContext: 'Could not load the product scope tree',
        missingContextDescription: 'The target product for this instance could not be resolved.',
        noNodes: 'The product scope tree is empty',
        noTask: 'No scope adjustment task is available',
        table: {
          headers: {
            kind: 'Type',
            name: 'Name',
            publishStatus: 'Publish Status'
          },
          kind: {
            FUNCTION: 'Function',
            MODULE: 'Module',
            PRODUCT: 'Product',
            SUB_MODULE: 'Sub Module'
          },
          publishStatus: {
            PUBLISHED: 'Published',
            UNPUBLISHED: 'Unpublished'
          }
        },
        title: 'Product Scope Tree'
      },
      detail: {
        assignInline: {
          assignSuccess: 'Assignee set',
          assigneeLabel: 'Assignee',
          assigneePlaceholder: 'Select an assignee',
          complete: 'Complete',
          loading: 'Loading assignee candidates…'
        }
      },
      progressTitle: 'Progress',
      requestedFor: 'Requested For',
      tabs: {
        ariaLabel: 'Product scope stocktaking tabs',
        data: 'Data',
        detail: 'Detail'
      }
    },
    list: {
      packageEmptyState: {
        description: 'The product scope stocktaking operation package is not available yet.',
        title: 'No operation package found'
      },
      patternEmptyState: {
        description: 'Add a pattern to start product scope stocktaking operations.',
        title: 'No patterns yet'
      },
      startNew: 'New Scope Stocktaking',
      taskEmptyState: {
        description: 'Start a new product scope stocktaking and it will be listed here.',
        title: 'No product scope stocktaking yet'
      }
    },
    targetSelection: {
      anchorDateLabel: 'Reference Date',
      missingPackageInfo: 'Operation package information is missing',
      missingPackageInfoDescription: 'Go back to the Product Planning Core and start again.',
      pageTitle: 'Select a Target Product',
      searchPlaceholder: 'Search by product name or code'
    }
  },
  sidebar: {
    productRoadmapChange: 'Product Roadmap Change',
    productRoadmapDrafting: 'Product Roadmap Planning',
    productScopeReconciliation: 'Product Scope Stocktaking',
    underDevelopment: 'This operation package is currently under development.',
    valueReconciliation: 'Value Stocktaking'
  },
  valueReconciliation: {
    anchorDate: {
      missingTarget: 'No target product selected',
      missingTargetDescription: 'Go back and select a target product.',
      pageTitle: 'Set the Reference Date',
      start: 'Start',
      startFailed: 'Failed to start value stocktaking',
      startSuccess: 'Value stocktaking started'
    },
    instance: {
      approveAll: 'Approve all',
      approveAllSuccess: 'Approved all successfully',
      assignee: 'Assignee',
      backToCore: 'Product Planning Core',
      cannotApproveAll: 'Cannot approve all because there are no waiting approval tasks',
      data: {
        aiRecommended: 'AI Recommended',
        complete: 'Complete Value Organizing',
        completeSuccess: 'Value organizing completed',
        description: 'Review the values linked to the target product. AI recommended candidates will be highlighted when available.',
        diff: {
          addedBadge: 'Proposed Addition',
          changedBadge: 'Proposed Change',
          field: {
            causeQualitative: 'Cause (Qualitative)',
            idealState: 'Ideal State',
            issue: 'Issue',
            layer: 'Layer',
            quantitativeNegativeImpact: 'Quantitative Negative Impact',
            status: 'Type',
            targetBusiness: 'Target Business',
            targetUser: 'Target User',
            title: 'Title',
            valueEffect: 'Value (Effect)',
            valueProposition: 'Value Proposition'
          },
          removedBadge: 'Proposed Removal',
          summaryAdded: 'Added: {{count}}',
          summaryChanged: 'Changed: {{count}}',
          summaryRemoved: 'Removed: {{count}}',
          summaryTitle: 'AI Proposed Changes'
        },
        missingContext: 'Could not load the value list',
        missingContextDescription: 'The target product for this instance could not be resolved.',
        noTask: 'No value organizing task is available',
        noValues: 'No values are linked to the target product',
        table: {
          headers: {
            code: 'No',
            methodCount: 'Methods',
            status: 'Type',
            title: 'Title'
          }
        },
        title: 'Value List'
      },
      detail: {
        assignInline: {
          assignSuccess: 'Assignee set',
          assigneeLabel: 'Assignee',
          assigneePlaceholder: 'Select an assignee',
          complete: 'Complete',
          loading: 'Loading assignee candidates…'
        }
      },
      organizeInDataTab: 'Review in the Data tab',
      organizeInDataTabDescription: 'Review the value list and complete this task in the Data tab.',
      progressTitle: 'Progress',
      requestedFor: 'Requested For',
      tabs: {
        ariaLabel: 'Value stocktaking tabs',
        data: 'Data',
        detail: 'Detail'
      }
    },
    list: {
      packageEmptyState: {
        description: 'The value stocktaking operation package is not available yet.',
        title: 'No operation package found'
      },
      patternEmptyState: {
        description: 'Add a pattern to start value stocktaking operations.',
        title: 'No patterns yet'
      },
      startNew: 'New Value Stocktaking',
      taskEmptyState: {
        description: 'Start a new value stocktaking and it will be listed here.',
        title: 'No value stocktaking yet'
      }
    },
    targetSelection: {
      anchorDateLabel: 'Reference Date',
      missingPackageInfo: 'Operation package information is missing',
      missingPackageInfoDescription: 'Go back to the Product Planning Core and start again.',
      pageTitle: 'Select a Target Product',
      searchPlaceholder: 'Search by product name or code'
    }
  }
};